export const CONTENT_STEP = {
  SELECT_DISTRICT: "selectDistrict",
  GET_RESULT: "getResult",
};

export const LIST_SI = [
  "강원도",
  "경기도",
  "경상남도",
  "경상북도",
  "광주광역시",
  "대구광역시",
  "대전광역시",
  "부산광역시",
  "서울특별시",
  "세종특별자치시",
  "울산광역시",
  "인천광역시",
  "전라남도",
  "전라북도",
  "제주특별자치도",
  "충청남도",
  "충청북도",
];

export const LIST_CANDIDATE = {
  a: "새천년민주당-노무현",
  b: "한나라당-이회창",
  c: "한나라당-이명박",
  d: "대통합민주신당-정동영",
  e: "무소속-이회창",
  f: "새누리당-박근혜",
  g: "민주통합당-문재인",
  h: "더불어민주당-문재인",
  i: "자유한국당-홍준표",
};

export const LIST_CANDIDATE_PARTY = {
  a: -1,
  b: 1,
  c: 1,
  d: -1,
  e: 1,
  f: 1,
  g: -1,
  h: -1,
  i: 1,
};
export const LIST_TYPEVOTE = {
  t: "보수철옹성",
  r: "진보철옹성",
  q: "높은 투표율",
  w: "낮은 투표율",
  u: "풍향계",
  z: "싱크로율 높음",
  x: "청개구리",
  v: "격전지",
  k: "족집게",
};

export const IMG_URL =
  "https://s3.ap-northeast-2.amazonaws.com/mabu.newscloud.sbs.co.kr/election2022/images";
